export const allSettingsSelector = state => state.settings.data;
export const siteMessageSelector = state => state.settings.siteMessage;